/* tslint:disable */
/* eslint-disable */
/**
 * NoRadio Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, localDateString } from '../runtime';
import type { FileId } from './FileId';
import { FileIdFromJSON, FileIdFromJSONTyped, FileIdToJSON } from './FileId';

/**
 *
 * @export
 * @interface EpisodeCreateModel
 */
export interface EpisodeCreateModel {
    /**
     *
     * @type {string}
     * @memberof EpisodeCreateModel
     */
    title: string;
    /**
     * Base64 encoded HTML
     * @type {string}
     * @memberof EpisodeCreateModel
     */
    html: string;
    /**
     *
     * @type {number}
     * @memberof EpisodeCreateModel
     */
    episodeNumber: number;
    /**
     *
     * @type {string}
     * @memberof EpisodeCreateModel
     */
    showId: string;
    /**
     *
     * @type {Date}
     * @memberof EpisodeCreateModel
     */
    originalDate: Date;
    /**
     *
     * @type {string}
     * @memberof EpisodeCreateModel
     */
    content: string;
    /**
     *
     * @type {string}
     * @memberof EpisodeCreateModel
     */
    shortContent: string;
    /**
     *
     * @type {FileId}
     * @memberof EpisodeCreateModel
     */
    fileId?: FileId;
}

/**
 * Check if a given object implements the EpisodeCreateModel interface.
 */
export function instanceOfEpisodeCreateModel(value: object): boolean {
    if (!('title' in value)) return false;
    if (!('html' in value)) return false;
    if (!('episodeNumber' in value)) return false;
    if (!('showId' in value)) return false;
    if (!('originalDate' in value)) return false;
    if (!('content' in value)) return false;
    if (!('shortContent' in value)) return false;
    return true;
}

export function EpisodeCreateModelFromJSON(json: any): EpisodeCreateModel {
    return EpisodeCreateModelFromJSONTyped(json, false);
}

export function EpisodeCreateModelFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): EpisodeCreateModel {
    if (json == null) {
        return json;
    }
    return {
        title: json['title'],
        html: json['html'],
        episodeNumber: json['episode_number'],
        showId: json['show_id'],
        originalDate: new Date(json['original_date']),
        content: json['content'],
        shortContent: json['short_content'],
        fileId: json['file_id'] == null ? undefined : FileIdFromJSON(json['file_id']),
    };
}

export function EpisodeCreateModelToJSON(value?: EpisodeCreateModel | null): any {
    if (value == null) {
        return value;
    }
    return {
        title: value['title'],
        html: value['html'],
        episode_number: value['episodeNumber'],
        show_id: value['showId'],
        original_date: localDateString(value['originalDate']),
        content: value['content'],
        short_content: value['shortContent'],
        file_id: FileIdToJSON(value['fileId']),
    };
}
